<template>
    <input type="text" :value="value" @input="inputChanged" @keydown.enter="onPressEnter" />
</template>

<script type="text/babel">
export default {
    props: ['value', 'types', 'country'],

    data() {
        return {
            autocomplete: null,
            acceptedLocation: null,
        }
    },

    computed: {
        location: {
            get() {
                return this.$get(this.form, this.field)
            },
            set(place) {
                let obj = {
                    name: this.$el.value,
                }

                try {
                    obj = {
                        name: this.$el.value,
                        address: place.formatted_address,
                        city: this.getCity(place),
                        place_id: place.place_id,
                        coordinates: {
                            latitude: place.geometry.location.lat(),
                            longitude: place.geometry.location.lng(),
                        },
                    }
                } catch (e) {
                    //
                }

                this.$set(this.form, this.field, obj)
            },
        },

        isDirty() {
            return this.$el.value !== this.acceptedLocation
        },

        options() {
            const options = {}

            if (this.types) {
                options.types = [this.types]
            }

            if (this.country) {
                options.componentRestrictions = {
                    country: this.country,
                }
            }

            return options
        },
    },

    mounted() {
        this.init()
    },

    methods: {
        init() {
            if (typeof google !== 'object') {
                return setTimeout(() => this.init(), 100)
            }

            this.autocomplete = new google.maps.places.Autocomplete(this.$el, this.options)
            this.autocomplete.addListener('place_changed', this.placeChanged)
        },

        inputChanged() {
            if (this.isDirty) {
                this.$emit('input', null)
                this.$emit('change', null)
            }
        },

        onPressEnter($e) {
            if (this.isDirty) {
                // Cancel the first 'enter' press when selecting place from dropdown
                $e.preventDefault()
            }
        },

        placeChanged() {
            const place = this.autocomplete.getPlace()
            if (typeof place.place_id !== 'undefined') {
                window.selectedGooglePlace = place
                this.acceptedLocation = this.$el.value
                this.$emit('input', this.$el.value)
                this.$emit('change', this.formatPlace(place))
            }
        },

        getCity(place) {
            let city = null
            try {
                place.address_components.forEach(function(component) {
                    component.types.forEach(function(type) {
                        if (type === 'sublocality' || type === 'locality') {
                            city = component.long_name
                            throw 'stop'
                        }
                    })
                })
            } catch (e) {
                //
            }
            return city
        },

        formatPlace(place) {
            let formatted = {
                name: this.$el.value,
                raw: place,
            }

            try {
                Object.assign(formatted, {
                    name: this.$el.value,
                    address: place.formatted_address,
                    city: this.getCity(place),
                    place_id: place.place_id,
                    coordinates: {
                        latitude: place.geometry.location.lat(),
                        longitude: place.geometry.location.lng(),
                    },
                })
            } catch (e) {
                //
            }

            return formatted
        },
    },
}
</script>
